import { Menu, MenuItem } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { AppBaseButton } from 'components/AppBaseButton/AppBaseButton';
import { ReactNode, ReactElement, useState } from 'react';

type MenuButtonProps = {
  disabled?: boolean;
  buttonText: ReactNode;
  buttonVariant?: ButtonProps['variant'];
  showIcon?: boolean;
  options: { value: string; text: string; disabled?: boolean }[];
  onMenuItemClicked: (value: string) => void;
};

export function MenuButton({
  disabled,
  buttonText,
  buttonVariant,
  showIcon = true,
  options,
  onMenuItemClicked,
}: MenuButtonProps): ReactElement {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const menuItemClicked = (value: string) => {
    closeMenu();
    onMenuItemClicked(value);
  };

  return (
    <>
      <AppBaseButton
        disabled={disabled}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        variant={buttonVariant}
        endIcon={showIcon && <ArrowDropDownIcon />}
      >
        {buttonText}
      </AppBaseButton>
      <Menu anchorEl={anchorEl} open={open} onClose={closeMenu}>
        {options.map((option, idx) => (
          <MenuItem onClick={() => menuItemClicked(option.value)} value={option.value} key={idx} disabled={option.disabled}>
            {option.text}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
